/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'product-featured-grid';
export class ProductFeaturedGrid extends Component {
    initTooltips = () => {
        const tooltipContainers = document.querySelectorAll(`.${componentName}__product-best-selling-tag`);

        tooltipContainers.forEach(container => {
            const tooltip = container.querySelector(`.${componentName}__tooltip`);

            if (!tooltip) return;

            // Show tooltip on mouse enter
            container.addEventListener('mouseenter', () => {
                if (container.getBoundingClientRect().right > (window.innerWidth - 160)) {
                    tooltip.classList.add('tooltip-left');
                } else if (container.getBoundingClientRect().left < 160) {
                    tooltip.classList.add('tooltip-right');
                } else {
                    tooltip.classList.remove('tooltip-left', 'tooltip-right');
                }
                tooltip.style.opacity = '1';
                tooltip.style.visibility = 'visible';
            });

            // Hide tooltip on mouse leave
            container.addEventListener('mouseleave', () => {
                tooltip.style.opacity = '0';
                tooltip.style.visibility = 'hidden';
                tooltip.classList.remove('tooltip-left', 'tooltip-right');
            });

            // Show tooltip on focus (for accessibility)
            container.addEventListener('focus', () => {
                if (container.getBoundingClientRect().right > (window.innerWidth - 160)) {
                    tooltip.classList.add('tooltip-left');
                } else if (container.getBoundingClientRect().left < 160) {
                    tooltip.classList.add('tooltip-right');
                } else {
                    tooltip.classList.remove('tooltip-left', 'tooltip-right');
                }
                tooltip.style.opacity = '1';
                tooltip.style.visibility = 'visible';
            });

            // Hide tooltip on blur (for accessibility)
            container.addEventListener('blur', () => {
                tooltip.style.opacity = '0';
                tooltip.style.visibility = 'hidden';
                tooltip.classList.remove('tooltip-left', 'tooltip-right');
            });
        });
    };

    initDom = () => {
        this.initTooltips();
    };

    /**
     * Initialize Component
     */
    init = () => {
        this.initDom();
    };
}

registerComponent(`.${componentName}`, ProductFeaturedGrid);
